import wootConstants from 'dashboard/constants/globals';

export default {
  methods: {
    setFilterAttributes() {
      const allCustomAttributes = this.$store.getters[
        'attributes/getAttributesByModel'
      ](this.attributeModel);
      const customAttributesFormatted = {
        name: this.$t(`${this.filtersFori18n}.GROUPS.CUSTOM_ATTRIBUTES`),
        attributes: allCustomAttributes.map(attr => {
          return {
            key: attr.attribute_key,
            name: attr.attribute_display_name || attr.attribute_key,
          };
        }),
      };
      const allFilterGroups = this.filterAttributeGroups.map(group => {
        return {
          name: this.$t(`${this.filtersFori18n}.GROUPS.${group.i18nGroup}`),
          attributes: group.attributes.map(attribute => {
            const i18nKey = (attribute.attributeI18nKey || attribute.key).toUpperCase();
            return {
              key: attribute.key,
              name: this.$t(`${this.filtersFori18n}.ATTRIBUTES.${i18nKey}`),
              attributeI18nKey: i18nKey,
            };
          }),
        };
      });
      const customAttributeTypes = allCustomAttributes.map(attr => {
        return {
          attributeKey: attr.attribute_key,
          attributeI18nKey: `CUSTOM_ATTRIBUTE_${attr.attribute_display_type.toUpperCase()}`,
          inputType: this.customAttributeInputType(attr.attribute_display_type),
          filterOperators: this.getOperatorTypes(attr.attribute_display_type),
          attributeModel: 'custom_attributes',
        };
      });
      this.filterTypes = [...this.filterTypes, ...customAttributeTypes];
      this.filterGroups = [...allFilterGroups, customAttributesFormatted];
    },

    initializeExistingFilterToModal() {
      this.initializeStatusAndAssigneeFilterToModal();
      this.initializeContextFilters();
    },
    initializeStatusAndAssigneeFilterToModal() {
      if (this.activeStatus !== '') {
        this.appliedFilter.push({
          attribute_key: 'status',
          attribute_model: 'standard',
          filter_operator: 'equal_to',
          values: [
            {
              id: this.activeStatus,
              name: this.$t(
                `CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${this.activeStatus}.TEXT`
              ),
            },
          ],
          query_operator: 'and',
          custom_attribute_type: '',
        });
      }
      if (this.activeAssigneeTab === wootConstants.ASSIGNEE_TYPE.ME) {
        this.appliedFilter.push({
          attribute_key: 'assignee_id',
          filter_operator: 'equal_to',
          values: this.currentUserDetails,
          query_operator: 'and',
          custom_attribute_type: '',
        });
      }
    },
    initializeContextFilters() {
      this.appendRouteFilter({
        attributeKey: 'inbox_id',
        valueId: this.conversationInbox,
        valueName: this.inbox?.name,
      });
      if (this.teamId && this.activeTeam?.id) {
        const { id, name } = this.activeTeam;
        this.appendRouteFilter({
          attributeKey: 'team_id',
          valueId: id,
          valueName: name,
          rawValues: this.activeTeam,
        });
      }
      this.appendRouteFilter({
        attributeKey: 'labels',
        valueId: this.label,
        valueName: this.label,
      });
      this.appendRouteFilter({
        attributeKey: 'product_labels',
        valueId: this.productLabel,
        valueName: this.productLabel,
      });
      this.appendRouteFilter({
        attributeKey: 'topic_labels',
        valueId: this.topicLabel,
        valueName: this.topicLabel,
      });
      this.appendRouteFilter({
        attributeKey: 'concurrent_labels',
        valueId: this.concurrentLabel,
        valueName: this.concurrentLabel,
      });
    },
    appendRouteFilter({
      attributeKey,
      valueId,
      valueName,
      rawValues = null,
    }) {
      if (!valueId || this.hasRouteFilter(attributeKey, valueId)) return;

      const valuesPayload = rawValues
        ? rawValues
        : [
            {
              id: valueId,
              name: valueName,
            },
          ];

      this.appliedFilter.push({
        attribute_key: attributeKey,
        attribute_model: 'standard',
        filter_operator: 'equal_to',
        values: Array.isArray(valuesPayload) ? valuesPayload : [valuesPayload],
        query_operator: 'and',
        custom_attribute_type: '',
      });
    },
    hasRouteFilter(attributeKey, valueId) {
      if (!valueId) return false;
      return this.appliedFilter.some(filter => {
        if (filter.attribute_key !== attributeKey) return false;
        const currentValue = Array.isArray(filter.values)
          ? filter.values[0]
          : filter.values;
        return currentValue?.id === valueId;
      });
    },
  },
};
